import { validateAgainstSchema } from "./util.validation.z"
import type { z } from "zod"
import type { NextFunction, Request, Response } from "express"

interface ZSchemaOptions {
    bodySchema?: z.ZodObject<z.ZodRawShape> | any;
    paramSchema?: z.ZodObject<z.ZodRawShape>;
}

export class ZSchema {
    bodySchema?: z.ZodObject<z.ZodRawShape>;
    paramSchema?: z.ZodObject<z.ZodRawShape>;

    constructor(options: ZSchemaOptions) {
        this.bodySchema = options.bodySchema;
        this.paramSchema = options.paramSchema;
    }

    validate = (req: Request, res: Response, next: NextFunction) => {
        // Validate body
        if (this.bodySchema) {
            const bodyValidationReturn = validateAgainstSchema(this.bodySchema, req.body);
            if (bodyValidationReturn.errors) {
                return res.status(400).json({ errors: bodyValidationReturn.errors });
            }
        }

        // Validate params
        if (this.paramSchema) {
            const paramsValidationReturn = validateAgainstSchema(this.paramSchema, req.params);
            if (paramsValidationReturn.errors) {
                return res.status(400).json({ errors: paramsValidationReturn.errors });
            }
        }

        // Both pass ? allow next : 400 returned with errors json
        next();
    }
}